import { render, staticRenderFns } from "./UnsavedChangesPrompt.vue?vue&type=template&id=72cdafb6&scoped=true"
import script from "./UnsavedChangesPrompt.vue?vue&type=script&lang=ts"
export * from "./UnsavedChangesPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdafb6",
  null
  
)

export default component.exports